import { render, staticRenderFns } from "./purchaseRetrunRedHis.vue?vue&type=template&id=010b6f81&scoped=true"
import script from "./purchaseRetrunRedHis.vue?vue&type=script&lang=js"
export * from "./purchaseRetrunRedHis.vue?vue&type=script&lang=js"
import style0 from "./purchaseRetrunRedHis.vue?vue&type=style&index=0&id=010b6f81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b6f81",
  null
  
)

export default component.exports